import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#520000', 
          secondary: '#2B0606', 
          danger: '#D33C47',
          anchor: '#F9DEC7',
          white: '#ffffff',
          topbar: '#383432',
          background: '#C94938',
          orange: '#036838',
          breadcrumbs: '#ffffff',
          carrito : '#520000'
        },
      },
    },
    icons: {
      iconfont: 'mdi',
    },
  })

export default vuetify;
